import cookie from 'cookie'
import { PureComponent } from 'react'
import { login } from 'shared/api'

let savedToken
const CSRFToken = WrapedComponent =>
    class CSRFTokenHOC extends PureComponent {
        state = {}
        async componentDidMount() {
            if (!savedToken) {
                await login()
                const csrftoken = cookie.parse(document.cookie).csrftoken
                savedToken = csrftoken
                this.setState({ csrftoken })
            } else {
                this.setState({ csrftoken: savedToken })
            }
        }

        render() {
            return <WrapedComponent {...this.props} {...this.state} />
        }
    }

export default CSRFToken
